import React from 'react';
import { Navigate, Outlet } from 'react-router-dom'
import { getAccessToken } from '../service/AuthService';

const PublicRoute = () => {
    return (
        !getAccessToken() ? <Outlet/>
        : <Navigate to={{ pathname: '/daily-content'}} />     
    )
}

export default PublicRoute;